import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Title } from '../../ui/text'
import { Edit } from '../../../assets/icons'

const Container = styled.div`
	width: 100%;
	min-width: 100px;
	max-width: 390px;
	display: flex;
	flex-direction: column;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
  		min-width: 100px;
	  	max-width: 600px;
	}
`

const Section = styled.div`
	margin-bottom: 0;
`

const SectionTitle = styled.h2`
	font-size: 20px;
	font-weight: 600;
	color: #1f2937;
	margin: 32px 0 16px 0;
`

const FieldContainer = styled.div`
	margin-bottom: 10px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		margin-bottom: 0px;
	}
`

const FieldWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
`

const FieldContent = styled.div`
	flex: 1;
`

const Label = styled.label`
	display: block;
	color: #1a1d23ff;
	font-weight: 600;
	font-size: 16px;
	margin-bottom: 4px;
`

const Value = styled.p`
	color: #717984ff;
	margin: 4px 0;
`

const EditButton = styled.button`
	color: #6b7280;
	transition: color 0.2s;
	padding: 4px;
	background: none;
	border: none;
	cursor: pointer;
	flex-shrink: 0;

	&:hover {
		color: #1f2937;
	}
`

function ChangeUserData({ auth = {}, patient = {} }) {
	const history = useHistory()
	const buildUserData = (authData, patientData) => ({
		password: '**********',
		email: authData?.email || '',
		fullName: [authData?.nombre, authData?.apellido].filter(Boolean).join(' ').trim(),
		documentNumber: authData?.nroDocumento || patientData?.numeroDocumento || '',
		medicalCoverage: authData?.obraSocial || patientData?.coberturaMedica || '',
		plan: authData?.plan || patientData?.planLineaCartilla || '',
		affiliateNumber: authData?.nroAfiliado || patientData?.nroAfiliado || '',
		phoneNumber: authData?.telefono || patientData?.telefono || ''
	})

	const [userData, setUserData] = useState(buildUserData(auth, patient))

	const [editingField, setEditingField] = useState(null)

	useEffect(() => {
		setUserData(buildUserData(auth, patient))
	}, [auth, patient])

	const handleEdit = fieldRoute => {
		history.push(fieldRoute)
	}

	const renderField = (field, label, editable = false, fieldRoute = '') => {
		const isEditing = editingField === field

		return (
			<FieldContainer>
				<FieldWrapper>
					<FieldContent>
						<Label>{label}</Label>
						<Value>{userData[field]}</Value>
					</FieldContent>
					{editable && !isEditing && (
						<EditButton
							onClick={() => handleEdit(fieldRoute)}
							aria-label={`Editar ${label.toLowerCase()}`}
							title="Editar"
						>
							<Edit color='#161616' />
						</EditButton>
					)}
				</FieldWrapper>
			</FieldContainer>
		)
	}

	return (
		<Container>
			<Title color="#161616" margin="0" size="24px">Mis datos</Title>
			<Section>
				<SectionTitle>Datos de usuario</SectionTitle>
				{renderField('password', 'Contraseña', true, 'mis-datos/cambiar-contrasenia')}
				{renderField('email', 'Email', true, 'mis-datos/cambiar-email')}
			</Section>
			<Section last>
				<SectionTitle>Datos personales</SectionTitle>
				{renderField('fullName', 'Nombre y apellido', false, 'mis-datos/cambiar-nombre-y-apellido')}
				{renderField('phoneNumber', 'Número de celular', false, 'mis-datos/cambiar-telefono')}
				{renderField('documentNumber', 'Número de documento')}
				{renderField('medicalCoverage', 'Cobertura médica')}
				{renderField('plan', 'Plan/Línea/Cartilla')}
				{renderField('affiliateNumber', 'Número de afiliado')}
			</Section>
		</Container>
	)
	
}

const mapStateToProps = (state = {}) => ({
	auth: state.auth || {},
	patient: state.patient || {}
})

export default connect(mapStateToProps)(ChangeUserData)
